// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaTwitter, FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => (
  <footer className="footer" role="contentinfo">
    <div className="container">
      <div className="row">
        {/* Sección del logo y descripción */}
        <div className="col-md-4 mb-4 mb-md-0">
          <Link to="/" className="footer-logo">
            <img src="/assets/img/logo.png" alt="Smart Money Logo" style={{ maxWidth: '150px', margin: '15px' }} />
          </Link>
          <p>
            Smart Money es la solución ideal para el intercambio de divisas. Envía y recibe en cualquier dirección: USD, Euros, Bs, COP y más.
          </p>
          <p className="social">
            <a href="#" ><FaTwitter size={20} /></a>
            <a href="#"><FaFacebookF size={20} /></a>
            <a href="#"><FaInstagram size={20} /></a>
            <a href="#"><FaLinkedinIn size={20} /></a>
          </p>
        </div>
        {/* Sección de navegación y soporte */}
        <div className="col-md-7 ms-auto">
          <div className="row">
            <div className="col-md-4 mb-4 mb-md-0">
              <h3>Navegación</h3>
              <ul className="list-unstyled">
                <li><Link to="/">Inicio</Link></li>
                <li><Link to="/envios">Realizar Envío</Link></li>
                <li><Link to="/tasas">Tasas de Cambio</Link></li>
                <li><Link to="/contact">Contacto</Link></li>
              </ul>
            </div>
            <div className="col-md-4 mb-4 mb-md-0">
              <h3>Soporte</h3>
              <ul className="list-unstyled">
                <li><Link to="/faq">Preguntas Frecuentes</Link></li>
                {/* <li><Link to="/ayuda">Centro de Ayuda</Link></li> */}
                <li><Link to="/seguridad">Seguridad</Link></li>
              </ul>
            </div>
            <div className="col-md-4 mb-4 mb-md-0">
              <h3>Descargas</h3>
              <ul className="list-unstyled">
                <li><a href="#">App Store</a></li>
                <li><a href="#">Google Play</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Sección final de copyright */}
      <div className="row justify-content-center text-center mt-3">
        <div className="col-md-7">
          <p>&copy; Copyright Smart Money. Todos los derechos reservados.</p>
          <p>
            Diseñado por <a href="https://rjvelazquez.web.app/">Roberto Velazquez</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
